import React from 'react'
import TaskOptions from './TaskOptions'
import CustomItemModalBox from './CustomItemModalBox'

class ScheduleTimelineItem extends React.Component {
  handleCheck() {
    if (this.props.data.just_looking) {
      return this.props.handleJustLookingClick(true);
    } else {
      const { timeline_id } = this.props.data;
      const check = !this.props.data.check_status;
      $.post("/timeline_items/save_checkbox" , {timeline_id, checked: check}, data => {
        return this.props.onTimelineCheck(data);
      });
    }
  }

  completedClass() {
    if (this.props.data.check_status) {
      return 'completed';
    } else {
      return '';
    }
  }

  handleItemClick() {
    if (this.props.data.just_looking) {
      return this.props.handleJustLookingClick(true);
    } else {
      const fetchEndpoint = `/timeline_items/${this.props.data.timeline_id}/fetch_details`
      $.getJSON(fetchEndpoint, {fetch_link: true}, data => {
        gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
        return this.props.handleItemClick('timeline_event', this.props.data.id, data.description, data.image_url, data.association, null, data.item_files);
      });
    }
  }

  handleCustomTaskClick() {
    return this.props.handleCustomTaskClick(this.props.data.id);
  }

  handleCustomTaskClose(){
    return this.props.handleCustomTaskClick('');
  }
  customTaskModal() {
    return this.props.custom_task_modal === this.props.data.id;
  }

  renderTimelineCheckBox() {
    if(!this.props.isLeavePlanPartner){
      return(
        <div className='rounded-checkbox'>
          <input className='timeline-check' id={`timeline-${this.props.data.id}`} type='checkbox' defaultChecked={this.props.data.check_status}/>
          <label htmlFor={`timeline-${this.props.data.id}`} onClick={this.handleCheck.bind(this)} />
        </div>
      )
    }
  }

  renderCustomItemModalBox() {
    if(this.customTaskModal()){
      return(
        <CustomItemModalBox
          handleClose={this._handleClose}
          handleClick={this._handleClick}
          item={this.props.data}
          editMode={true}
          handleCustomTaskChange={this.props.handleCustomTaskChange}
          handleCustomTaskClose={this.handleCustomTaskClose.bind(this)}
          disabledTaskEmailNotifications={this.props.disabledTaskEmailNotifications}
        />
      );
    }
  }

  render() {
    return (
      <div className={`timeline-item ${this.completedClass()}`}>
        <div className='checkbox-title-wrapper'>
          { this.renderTimelineCheckBox() }
          <span onClick={this.handleItemClick.bind(this)} className={`timeline-name ${this.props.class_name}`}>
            {this.props.data.name}
          </span>
        </div>
        <div className='task-options'>
          <span>
            {this.props.data.event_type}
          </span>
          <TaskOptions
            data={this.props.data}
            onHelpfulCheck={this.props.onHelpfulCheck}
            handleClick={this._handleClick}
            handleCustomTaskDelete={this.props.handleCustomTaskDelete}
            handleCustomTaskClick={this.handleCustomTaskClick.bind(this)}
            isLeavePlanPartner={this.props.isLeavePlanPartner}
            disabledTaskEmailNotifications={this.props.disabledTaskEmailNotifications}
          />
        </div>
        {this.renderCustomItemModalBox()}
      </div>
    );
  }
}

export default ScheduleTimelineItem
